import type { Metadata } from 'next'

const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

/** 404 boundaries stay out of the index and do not inherit the layout canonical. */
export const notFoundMetadata = {
	robots: { index: false, follow: isProduction },
	alternates: { canonical: null },
} satisfies Metadata
